import { type BlockViewProps } from '@plone/types';
import './productstitle.scss';
import MenuDesktop from '../PageTitleWithMenu/menudesktop';
import MenuMobile from '../PageTitleWithMenu/menumobile';
import { useMediaQuery } from 'usehooks-ts';
export interface ProductsTitleData {
  '@type': 'productstitle';
  placeholder?: string;
}

type Props = BlockViewProps & {
  data: ProductsTitleData;
};

const ProductsBlockView = ({ properties, metadata }: Props) => {
  const isProduct = properties['@type'] === 'Product';
  const productUrl = isProduct ? properties['@id'] : properties.parent['@id'];
  const parent_id = isProduct ? properties.parent['id'] : properties['id'];
  const product_title = isProduct ? properties.title : properties.parent.title;
  const section_title = !isProduct ? properties.title : null;
  const titleasp = !isProduct;
  // setting items
  const items = [
    {
      '@id': productUrl,
      id: 'overview',
      title: 'Overview',
      active: isProduct ? 'active' : undefined,
    },
    // @ts-expect-error
    ...(isProduct ? properties?.items : properties.parent?.items || [])
      .filter((item) => !item.exclude_from_nav)
      .map((item) => ({
        ...item,
        active: properties.id === item.id ? 'active' : null,
      })),
  ];
  const isMobile = useMediaQuery('(max-width: 1199px)');
  return isMobile ? (
    <MenuMobile
      items={items}
      id={parent_id}
      title={product_title}
      parent_title={section_title}
      titleasp={titleasp}
    />
  ) : (
    <MenuDesktop
      items={items}
      isEditMode={false}
      title={product_title}
      parent_title={product_title}
      titleasp={titleasp}
    />
  );
};

export default ProductsBlockView;
